export default "__VITE_ASSET__4yP8Qo9j__"